import styled from '@emotion/styled'
import { themeUtils } from 'styles/theme'

export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  ${themeUtils.maxWidth.md} {
    align-items: flex-end;
    padding: 0 16px;
  }
`

export const BannerTitle = styled.h1`
  ${themeUtils.h2}
  ${themeUtils.maxWidth.sm} {
    font-size: 20px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    grid-row: 2;
  }
`

export const ButtonHeartContainer = styled.div`
  ${themeUtils.maxWidth.sm} {
    grid-row: 2;
    align-self: flex-end;
  }
`
